namespace Matrix.Data {
    export interface ClientTableParseRequest extends Serenity.ServiceRequest {
        TableSchema?: string;
        Tablename?: string;
    }
}
